﻿import { Decorators } from "@serenity-is/corelib";

export enum EmailQueuePriority {
    High = 1,
    Medium = 2,
    Low = 3
}
Decorators.registerEnumType(EmailQueuePriority, 'Serenity.Pro.EmailQueue.EmailQueuePriority');